import { render, staticRenderFns } from "./ShareUserRow.vue?vue&type=template&id=b43a8d40&scoped=true"
import script from "./ShareUserRow.vue?vue&type=script&lang=ts"
export * from "./ShareUserRow.vue?vue&type=script&lang=ts"
import style0 from "./ShareUserRow.vue?vue&type=style&index=0&id=b43a8d40&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43a8d40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b43a8d40')) {
      api.createRecord('b43a8d40', component.options)
    } else {
      api.reload('b43a8d40', component.options)
    }
    module.hot.accept("./ShareUserRow.vue?vue&type=template&id=b43a8d40&scoped=true", function () {
      api.rerender('b43a8d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShareUserRow.vue"
export default component.exports